<template>
  <base-dialog :active="displayTitleAndDescriptionDialog" :title="t('common.Edit title and description')"
    :cancel-text="t('common.Cancel')" :confirm-text="t('common.OK')" @close="close" @cancel="close"
    @confirm="setTitleAndDescription">
    <div class="p-4 space-y-4">
      <div class="mb-4">
        <label class="block text-sm font-medium text-stone-700 dark:text-stone-300 mb-1">
          {{ t('common.Wheel title') }}
        </label>
        <input type="text" v-model="wheelTitle" ref="wheelTitleInput" @keydown.enter="enterPressed" maxlength="50"
          class="w-full px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:opacity-50 dark:bg-stone-700 dark:text-stone-200">
      </div>

      <div>
        <label class="block text-sm font-medium text-stone-700 dark:text-stone-300 mb-1">
          {{ t('common.Wheel description') }}
        </label>
        <textarea v-model="wheelDescription" @keydown.enter="enterPressed" maxlength="200" rows="4"
          class="w-full px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-md shadow-sm focus:outline-none focus:ring-primary-500 focus:border-primary-500 disabled:opacity-50 dark:bg-stone-700 dark:text-stone-200 resize-none"></textarea>
      </div>
    </div>
  </base-dialog>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWheelStore } from '@/stores/useWheelStore';
import BaseDialog from '../shared/BaseDialog.vue';

const { t } = useI18n();
const wheelStore = useWheelStore();

const emit = defineEmits(['setTitleAndDescription']);

const displayTitleAndDescriptionDialog = ref(false);
const wheelTitle = ref('');
const wheelDescription = ref('');
const wheelTitleInput = ref(null);

const wheelConfig = computed(() => wheelStore.wheelConfig);

const show = () => {
  wheelTitle.value = wheelConfig.value.title;
  wheelDescription.value = wheelConfig.value.description;
  displayTitleAndDescriptionDialog.value = true;
  setTimeout(() => { if (wheelTitleInput.value && wheelTitleInput.value.focus) wheelTitleInput.value.focus(); }, 100);
};

const enterPressed = (e) => {
  e.preventDefault();
  setTitleAndDescription();
};

const setTitleAndDescription = () => {
  emit('setTitleAndDescription', {
    title: wheelTitle.value,
    description: wheelDescription.value
  });
  close();
};

const close = () => {
  displayTitleAndDescriptionDialog.value = false;
  wheelTitle.value = '';
  wheelDescription.value = '';
};

defineExpose({ show, close });
</script>
